import setFolderSortBy from './actions/setFolderSortBy';
import emptyFolderStitch from './stitches/emptyFolderStitch';
import markAllAsReadStitch from './stitches/markAllAsReadStitch';
import loadMailFolders from './actions/loadMailFolders';
import showHideMoveFolderDialog from './actions/showHideMoveFolderDialog';
import setMoveToFolderId from './actions/setMoveToFolderId';
import showErrorMessage from './utils/showErrorMessage';
import isSortingPersisted from './utils/isSortingPersisted';
import logRootFolderNodeClick from './utils/logRootFolderNodeClick';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { runAfterBootstrap } from 'owa-delayed-initialization';

// Import orchestrators so they are registered
import './orchestrators/deleteItemsStoreUpdateOrchestrator';
import './orchestrators/loadMailFolders';
import './orchestrators/setFolderSortByOrchestrator';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailFolderStore" */ './lazyIndex')
);

export {
    loadMailFolders,
    logRootFolderNodeClick,
    showErrorMessage,
    setFolderSortBy,
    isSortingPersisted,
    showHideMoveFolderDialog,
    setMoveToFolderId,
};

export let lazyDismissMailFolderTextField = new LazyAction(
    lazyModule,
    m => m.dismissMailFolderTextField
);
export let lazyRenameFolder = new LazyAction(lazyModule, m => m.renameFolderFromTextField);

export let lazyNewFolderFromTextField = new LazyAction(
    lazyModule,
    m => m.createNewFolderFromNewFolderTextField
);

export let lazyCreateNewFolder = new LazyImport(lazyModule, m => m.createNewFolder);
export let lazyMoveFolder = new LazyAction(lazyModule, m => m.moveFolder);

export let lazyToggleFolderTreeExpansion = new LazyAction(
    lazyModule,
    m => m.toggleFolderTreeExpansion
);

runAfterBootstrap(() => {
    // Stitches
    emptyFolderStitch();
    markAllAsReadStitch();
});
